// extracted by mini-css-extract-plugin
export default {"DeleteLabel":"MusicAction_DeleteLabel__GXwaR"};